import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { columnsDef } from 'src/app/interfaces/columnsDef';
import { MaskEditField } from 'src/app/interfaces/user-authentication';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';

@Component({
    selector: 'app-form-view-input',
    templateUrl: './form-view-input.component.html',
    styleUrls: ['./form-view-input.component.css'],
    standalone: false
})
export class FormViewInputComponent implements OnInit,AfterViewInit {

  toolTipText = null;
  config:columnsDef;
  group: UntypedFormGroup;
  row: Object;
  componentHidden:Boolean = false;
  maskEditField:MaskEditField;
  entityName:string;
  entityDesc:string;
  tabindex:string;
  canConfig:boolean = false;
  showBuscaDados:boolean = true;

  @Output() editEvent:EventEmitter<boolean> = new EventEmitter();

  @Output() blurEvent:EventEmitter<boolean> = new EventEmitter();
  bluring(event){
      this.blurEvent.next(event)
  }
  constructor(public dynaServices:DynamicFormsService,private cd:ChangeDetectorRef) { }

  ngAfterViewInit(){
    if ( this.maskEditField != null){
      if ( this.maskEditField.padding !=null){
        let value = this.group.get(this.config.COLUMNNAME).value;
        if ( value != null ){
          let m = this.maskEditField.mask;
          m = m.replace(/\./g,'');
          let k = value.toString().padStart(m.length,'0');
          this.group.get(this.config.COLUMNNAME).patchValue(k);
          this.cd.detectChanges();
        }
        
      }
    }    
  }

  ngOnInit() {
      
    
  }

  format(evento,value){
      
     if ( this.maskEditField.mask.indexOf("separator")>-1){
      let decimal =  this.maskEditField.mask.split(/\./g)[1];
      //value =  this.realValue.toString().split(/\./g)[0] + ", "+this.realValue.toString().split(/\./g)[1].padEnd(decimal,0);
     }
  }

  editing(){
    this.editEvent.next(true);
  }
}
